import { render, staticRenderFns } from "./LikeItemDetailLayout.vue?vue&type=template&id=4237f355&scoped=true&"
import script from "./LikeItemDetailLayout.vue?vue&type=script&lang=js&"
export * from "./LikeItemDetailLayout.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4237f355",
  null
  
)

export default component.exports